import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { ReactComponent as BackIcon } from '@pkg/assets/images/artifacts/back.svg';
import { ReactComponent as MuteIcon } from '@pkg/assets/images/artifacts/mute.svg';
import { ReactComponent as UnMuteIcon } from '@pkg/assets/images/artifacts/unmute.svg';
import { CircleButton } from '@pkg/components';

import './ArtifactsControls.scss';

interface ArtifactsControlsProps {
    expanded: boolean;
    muted: boolean;
    onClose: () => void;
    onMute: () => void;
}

export function ArtifactsControls({ expanded, muted, onClose, onMute }: ArtifactsControlsProps) {
    const { t } = useTranslation(['artifacts', 'words']);

    return (
        <div className="yat-artifacts__controls">
            <CircleButton ariaLabel={t('common:back')} size="xlarge" onClick={onClose}>
                {expanded ? <BackIcon /> : <CloseIcon />}
            </CircleButton>
            <CircleButton
                classes="yat-artifacts__controls__mute-button"
                ariaLabel={t('common:back')}
                size="xlarge"
                onClick={onMute}
            >
                {muted ? <UnMuteIcon /> : <MuteIcon />}
            </CircleButton>
        </div>
    );
}
